/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Instructions_Chip1_LabelInputs */



/**
* | output |
* | --- |
* | "What should I put here?" |
*
* @param {Uno_Edu_Project_Instructions_Chip1_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_instructions_chip1_label = /** @type {((inputs?: Uno_Edu_Project_Instructions_Chip1_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Instructions_Chip1_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was gehört hier hinein?")
	return /** @type {LocalizedString} */ ("What should I put here?")
});